export class SetLike {
    constructor(optionalOptions = {}) {
        this._likes = document.querySelectorAll('[data-action="like"]');

        if (!this._likes) {
            this.destructor();
            return true;
        }

        this._likes.forEach((button) => {
            button.addEventListener("click", (event) => {
                event.preventDefault()

                button.classList.toggle("active");

                return false
            })
        })
    }

    destructor() {
        this._likes = null;
    }
}

export default new SetLike();